import { useEffect, useState, useRef } from 'react';
import { AddItemToWishList, GetWishListItems, RemoveItemFromWishList } from '../Data';
import CategorySliderAR from './CategorySlider/CategorySliderAR';
import FeaturedProductAR from './FeaturedProduct/FeaturedProductAR';
import NewArrivalAR from './NewArrival/NewArrivalAR';
import OnSaleProductAR from './OnsaleProduct/OnSaleProductAR';
import Slider from './Slider/Slider';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { Global } from '../Variables/Global';
import ProductModalAR from '../Common/ProductModalAR';
import Cookies from 'js-cookie';


const HomeBodyAR = () => {
    const [widget3, setWidget1] = useState([]);
    const [widget4, setWidget2] = useState([]);
    const [widget5, setWidget3] = useState([]);
    const [featured, setFeatured] = useState([]);
    const [onsale, setOnsale] = useState([]);
    const [toprated, setToprated] = useState([]);
    const [WishListItems, setWishListItems] = useState([]);
    const [isLogged, setIsLogged] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [productDetails, setProductDetails] = useState();
    const token = Cookies.get("CustomerToken");
    const navigate = useNavigate();

    const getWidgets = async (widgetId) => {
        const URL = Global.API_URL + "Widgets/GetAssignedCategories/" + widgetId;
        await fetch(URL, {
            method: "Get",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": Global.API_URL,
            },
        })
            .then((resp) => {
                if (resp.ok) {
                    return resp.json();
                }
            })
            .then((result) => {
                switch (widgetId) {
                    case 1:
                        setWidget1(result)
                        getProductByCategoryId(result[0].CategoryId, 1);
                        break
                    case 2:
                        setWidget2(result)
                        getProductByCategoryId(result[0].CategoryId, 2);
                        break
                    case 3:
                        setWidget3(result)
                        getProductByCategoryId(result[0].CategoryId, 3);
                        break
                }

            }
            );
    }

    const getProductByCategoryId = async (categoryId, widgetId) => {
        var groupId;
        if (Cookies.get("WishList") !== undefined) {
            groupId = 4
        } else {
            groupId = 3
        }
        const offset = new Date().getTimezoneOffset();
        fetch(Global.API_URL + "Products/GetProductsByCategoryId", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": Global.API_URL,
            },
            body: JSON.stringify({
                categoryId: categoryId,
                pageId: 0,
                count: 7,
                offset: offset,
                attributes: [],
                categories: [],
                prices: [],
                groupId: groupId,
                countryId: 125,
            }),
        })
            .then((Response) => {
                if (Response.ok) return Response.json();
                else throw Error("Did Not Receive expected data");
            })
            .then((Result) => {
                switch (widgetId) {
                    case 1:
                        setFeatured(Result.finalList)
                        break
                    case 2:
                        setOnsale(Result.finalList)
                        break
                    case 3:
                        setToprated(Result.finalList)
                        break
                }
            })
    }

    const GetWishListItemsForHome = () => {
        var groupId;
        if (Cookies.get("WishList") !== undefined) {
            groupId = 4
        } else {
            groupId = 3
        }
        const getItem = (Cookies.get('WishList') !== undefined);
        if (getItem) {
            var WishlistId = Cookies.get("WishList");
            GetWishListItems(WishlistId, groupId, token).then((Result) => {
                setWishListItems(Result.WishlistItems);
            });
        }
    }

    const HandleAddToWishList = (ProductId, ProductVariationId) => {
        if (!isLogged) {
            navigate('/Authentication');
            return;
        }

        const WishlistId = Cookies.get("WishList");
        if (!WishlistId) return;

        AddItemToWishList(WishlistId, ProductId, ProductVariationId, token)
            .then(response => {
                if (!response.ok) throw new Error();
                return response.json();
            })
            .then(result => {
                toast.success("تمت الإضافة إلى المفضلة");

                // ✅ UPDATE STATE (important)
                setWishListItems(prev => [
                    ...prev,
                    {
                        ProductId,
                        DefaultProductVariationId: ProductVariationId
                    }
                ]);
            })
            .catch(() => {
                toast.error("تعذرت الإضافة");
            });
    };

    const HandleRemoveFromWishList = (ProductId) => {
        if (!isLogged) {
            navigate('/Authentication');
            return;
        }

        const WishlistId = Cookies.get("WishList");
        if (!WishlistId) return;

        RemoveItemFromWishList(ProductId, WishlistId, token)
            .then(response => {
                if (!response.ok) throw new Error();
                return response.json();
            })
            .then(() => {
                toast.success("تمت الإزالة من المفضلة");

                // ✅ UPDATE STATE (important)
                setWishListItems(prev =>
                    prev.filter(item => item.ProductId !== ProductId)
                );
            })
            .catch(() => {
                toast.error("تعذرت الإزالة");
            });
    };

    useEffect(() => {
        if (Cookies.get("CustomerToken") === undefined) {
            setIsLogged(false);
        } else {
            setIsLogged(true);
        }
        getWidgets(1);
        getWidgets(2);
        getWidgets(3);
        GetWishListItemsForHome();
    }, [])

    return (
        <>
            <Slider />
            <div className="policy-section mb-35">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="policy-titles d-flex align-items-center flex-wrap">
                                <div className="single-policy">
                                    <span><img width="30" height="25" src="assets/images/policy-ic1.png" className="img-fluid"
                                        alt="" /></span>
                                    <p>شحن مجاني للطلبات التي تزيد عن 200 دولار</p>
                                </div>

                                <div className="single-policy">
                                    <span><img width="30" height="29" src="assets/images/policy-icon2.png" className="img-fluid"
                                        alt="" /></span>
                                    <p> إسترجع أموالك خلال 30 يوما من بعد الدفع</p>
                                </div>

                                <div className="single-policy">
                                    <span><img width="30" height="29" src="assets/images/policy-icon3.png" className="img-fluid"
                                        alt="" /></span>
                                    <p> 24/7 الدعم</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="slider category-slider mb-35">
                <CategorySliderAR />
            </div>
            <div className="slider tab-slider mb-3 mt-3">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="tab-slider-wrapper">
                                <nav>
                                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                        <a className="nav-item nav-link active" id="featured-tab" data-bs-toggle="tab"
                                            href="#featured" role="tab" aria-selected="true">المنتجات المميزة</a>
                                        <a className="nav-item nav-link" id="new-arrival-tab" data-bs-toggle="tab"
                                            href="#new-arrivals" role="tab" aria-selected="false">المنتجات الاعلى تقييماً</a>
                                        <a className="nav-item nav-link" id="nav-onsale-tab" data-bs-toggle="tab" href="#on-sale"
                                            role="tab" aria-selected="false">عروضاتنا</a>
                                    </div>
                                </nav>

                                <div className="tab-content" id="nav-tabContent">
                                    <div className="tab-pane fade show active" id="featured" role="tabpanel"
                                        aria-labelledby="featured-tab">
                                        <div className='row'>
                                            {
                                                featured.length > 0 ? (
                                                    featured.map((product, index) => {
                                                        return (
                                                            <div key={index} className='col-lg-3 col-md-3 col-sm-6 col-xs-12'>

                                                                <FeaturedProductAR
                                                                    WishListItems={WishListItems}
                                                                    HandleAddToWishList={HandleAddToWishList}
                                                                    HandleRemoveFromWishList={HandleRemoveFromWishList}
                                                                    setShowModal={setShowModal}
                                                                    productDetails={productDetails}
                                                                    setProductDetails={setProductDetails}
                                                                    product={product}
                                                                />
                                                                {
                                                                    showModal && (
                                                                        <ProductModalAR
                                                                            productDetails={productDetails}
                                                                            showModal={showModal}
                                                                            setShowModal={setShowModal}
                                                                        />
                                                                    )
                                                                }
                                                            </div>
                                                        )
                                                    })
                                                ) : (
                                                    <h1>No Featured Product</h1>
                                                )
                                            }
                                        </div>
                                    </div>
                                    <div className="tab-pane fade" id="new-arrivals" role="tabpanel"
                                        aria-labelledby="new-arrival-tab">
                                        <div className='row'>
                                            {
                                                toprated.length > 0 ? (
                                                    toprated.map((product, index) => {
                                                        return (
                                                            <div key={index} className='col-lg-3 col-md-3 col-sm-6 col-xs-12'>
                                                                <NewArrivalAR
                                                                    WishListItems={WishListItems}
                                                                    HandleAddToWishList={HandleAddToWishList}
                                                                    HandleRemoveFromWishList={HandleRemoveFromWishList}
                                                                    setShowModal={setShowModal}
                                                                    productDetails={productDetails}
                                                                    setProductDetails={setProductDetails}
                                                                    product={product}
                                                                />
                                                                {
                                                                    showModal && (
                                                                        <ProductModalAR
                                                                            productDetails={productDetails}
                                                                            showModal={showModal}
                                                                            setShowModal={setShowModal}
                                                                        />
                                                                    )
                                                                }
                                                            </div>
                                                        )
                                                    })

                                                ) : (
                                                    <h1>لا توجد منتجات قادمة جديدة</h1>
                                                )
                                            }
                                        </div>
                                    </div>
                                    <div className="tab-pane fade" id="on-sale" role="tabpanel" aria-labelledby="nav-onsale-tab">
                                        {
                                            onsale.length > 0 ? (
                                                onsale.map((product, index) => {
                                                    return (
                                                        <div key={index} className='col-lg-3 col-md-3 col-sm-6 col-xs-12'>
                                                            <OnSaleProductAR
                                                                WishListItems={WishListItems}
                                                                HandleAddToWishList={HandleAddToWishList}
                                                                HandleRemoveFromWishList={HandleRemoveFromWishList}
                                                                setShowModal={setShowModal}
                                                                productDetails={productDetails}
                                                                setProductDetails={setProductDetails}
                                                                product={product}
                                                            />
                                                            {
                                                                showModal && (
                                                                    <ProductModalAR
                                                                        productDetails={productDetails}
                                                                        showModal={showModal}
                                                                        setShowModal={setShowModal}
                                                                    />
                                                                )
                                                            }
                                                        </div>
                                                    )
                                                })
                                            ) : (
                                                <h1>لا يوجد اوكازيون</h1>
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default HomeBodyAR